/**
 * SidenavRoot — Styled Drawer for Kadmin sidenav
 */

import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, whiteSidenav, miniSidenav, darkMode } = ownerState;

  const sidebarWidth = 260;
  const { pxToRem } = functions;

  const getBackground = () => {
    if (transparentSidenav) return "transparent";
    // whiteSidenav means "Light" - always use light background regardless of dark mode
    if (whiteSidenav) {
      return "rgba(255, 255, 255, 0.95)";
    }
    return darkMode ? (palette.background.sidenav || "#1A1F23") : "#1F2937";
  };

  const bgValue = getBackground();

  const openStyles = {
    background: bgValue,
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.easeOut,
      duration: transitions.duration.shorter,
    }),
    [breakpoints.up("xl")]: {
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.easeOut,
        duration: transitions.duration.enteringScreen,
      }),
    },
  };

  const closeStyles = {
    background: bgValue,
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.easeIn,
      duration: transitions.duration.shorter,
    }),
    [breakpoints.up("xl")]: {
      width: pxToRem(80),
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.easeIn,
        duration: transitions.duration.shorter,
      }),
    },
  };

  return {
    "& .MuiDrawer-paper": {
      boxShadow: transparentSidenav ? "none" : "0 4px 24px rgba(0,0,0,0.08)",
      border: "none",
      borderRadius: 0,
      ...(whiteSidenav && {
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
      }),
      ...(miniSidenav ? closeStyles : openStyles),
    },
  };
});
